import mergeWith from 'lodash/mergeWith';
import isSupportedLocales from './data/locales';

const DEFAULT_LOCALE = 'en_US';

export const interpolate = (...args) => {
  const str = args.shift();
  const context = args.length === 1 ? args[0] || {} : args;
  const { prototype: { toString } } = Object;

  return str.replace(/{([\s\S]+?)}/g, (match, interpolateStr) => {
    let replacer = interpolateStr
      .split('.')
      .reduce((acc, k) => (acc && acc[k]), context);
    if (toString.call(replacer) === '[object Function]') {
      replacer = replacer(interpolateStr);
    }
    /* eslint-disable no-void */
    return replacer === null || replacer === void 0 ? '' : replacer;
  });
};

export const loadI18nMsg = (locale, callback) => {
  const loadingLocale = isSupportedLocales(locale) ? locale : DEFAULT_LOCALE;
  const modules = [
    import(`../../i18n/${loadingLocale}.json`),
  ];

  Promise.all(modules).then((messages) => {
    callback(Object.assign({}, ...messages));
  });
};

export const appendNode = (...args) => {
  const AVAILABLE_ELEMENT_NODES = [ 'link', 'script' ];
  let tar = document.body;
  let tag;
  let attr;
  if (args.length === 0) {
    return null;
  }
  if (args.length < 3) {
    [ tag, attr = {} ] = args;
  } else {
    [ tar, tag, attr ] = args;
  }
  if (!AVAILABLE_ELEMENT_NODES.includes(tag)) return null;
  const dom = document.createElement(tag);
  Object.keys(attr).forEach(key => dom.setAttribute(key, attr[key]));
  return tar.appendChild(dom);
};

export const appendScript = (config) => {
  const { src, allowedExist, onload } = config;

  const existScript = Array.from(document.scripts).filter(s => s.src === src)[0];
  if (!allowedExist && existScript) {
    return existScript;
  }

  let scriptNode;
  const attr = mergeWith(
    { type: 'text/javascript', src },
    onload && typeof onload === 'function' ? {
      onreadystatechange: () => {
        const { readyState } = scriptNode;
        if (readyState === 'loaded' || readyState === 'complete') {
          scriptNode.onreadystatechange = null;
          onload();
        }
      },
      onload,
    } : {},
  );
  scriptNode = appendNode(document.head, 'script', attr);
  return scriptNode;
};

export const appendCss = config => appendNode(document.head, 'link', mergeWith({
  type: 'text/css', rel: 'stylesheet',
}, (typeof config === 'string' ? { href: config } : config)));

export const omit = (obj, omitKeys = []) => (
  Object.keys(obj).reduce(
    (acc, key) => (omitKeys.indexOf(key) === -1 ? Object.assign(acc, { [key]: obj[key] }) : acc),
    {},
  )
);
